export class Perfil{
  id?: number;
  nome?: string;
  ativo?: boolean;
  admin?: boolean;


  constructor(id?: number, nome?: string, ativo?: boolean, admin?: boolean) {
    this.id = id;
    this.nome = nome;
    this.ativo = ativo;
    this.admin = admin;
  }


}
